/**
 * Service for fetching advertising content from the backend
 */

import { buildApiUrl } from '../utils/apiConfig';
import { jsonGet } from '../utils/http';
import { AdvertisingContent } from '../types/advertising';

/**
 * Fetches the advertising content from the backend API
 * @returns Promise<AdvertisingContent[]> - Returns array of advertising content
 */
export const fetchAdvertisingContent = async (): Promise<AdvertisingContent[]> => {
  try {
    const url = buildApiUrl('api/advertising/content');
    return await jsonGet<AdvertisingContent[]>(url, true);
  } catch (error) {
    console.error('Error fetching advertising content:', error);
    throw error;
  }
};


